// Blocks available everywhere
export const blocksAvailableEverywhere = [
  // leave empty to disable the "everywhere" rule
];

// Blocks hidden everywhere unless explicitly enabled per type
export const blocksAvailableNowhere = [
  'gridBlock', 'teaser', '__grid', 'teaserGrid', 'imagesGrid', 'button', 'carousel', 'highlight', 'separator', 'slider',
];

// Blocks allowed per content type
export const blocksPerContentType = {
  //'News Item': ['title', 'slate'],
  //Event: ['title', 'slate', 'image', 'maps', 'teaser'],
  //Document: ['title', 'slate', 'image', 'listing', 'teaser', 'video'],
};

// Blocks hidden per group
export const blocksHiddenForGroups = {
  Editors: { 
    '*': ['html', 'iframe', 'form'],
    // Event: ['maps'] 
  },
};

// --- helpers ---
const asSet = (arr) => new Set(Array.isArray(arr) ? arr : []);
const nowhereSet = asSet(blocksAvailableNowhere);
const everywhereSet = asSet(blocksAvailableEverywhere);
const everywhereActive = blocksAvailableEverywhere?.length > 0;

const getUserGroups = (user) => {
  const groups = new Set();
  if (Array.isArray(user?.roles)) user.roles.forEach((r) => groups.add(r));
  if (Array.isArray(user?.groups)) user.groups.forEach((g) => groups.add(g));
  if (Array.isArray(user?.groups?.items))
    user.groups.items.forEach((g) => groups.add(g?.id || g?.title || g));
  return Array.from(groups).filter(Boolean).map(String);
};

const runOriginal = (originalRestricted, ctx) =>
  typeof originalRestricted === 'function'
    ? originalRestricted(ctx)
    : Boolean(originalRestricted);

/**
 * Main restriction function
 * Rules priority:
 * 1) Group hiding
 * 2) Per-content-type allow-list
 * 3) Nowhere
 * 4) Everywhere (only if list is non-empty)
 * 5) Fallback to the block’s original restricted
 */
export const buildRestriction = (blockId, originalRestricted) => {
  return (ctx) => {
    const { contentType, user } = ctx;
    const allowedForType = asSet(blocksPerContentType[contentType] || []);

    // 1) Group hiding
    const userGroups = getUserGroups(user);
    for (const grp of userGroups) {
      const rules = blocksHiddenForGroups[grp];
      if (!rules) continue;
      const globalHidden = asSet(rules['*'] || rules.all || []);
      const typeHidden = asSet(rules[contentType] || []);
      if (globalHidden.has(blockId) || typeHidden.has(blockId)) return true;
    }

    // 2) Per-content-type overrides
    if (blocksPerContentType[contentType]) {
      if (allowedForType.has(blockId)) return runOriginal(originalRestricted, ctx);
      return true; // not on the allow-list for this type
    }

    // 3) Nowhere
    if (nowhereSet.has(blockId)) return true;

    // 4) Everywhere only if the list is active (non-empty)
    if (everywhereActive && everywhereSet.has(blockId)) {
      return runOriginal(originalRestricted, ctx);
    }

    // 5) Safe fallback: respect the block’s own restriction
    return runOriginal(originalRestricted, ctx);
  };
};
